import { AbstractControl } from '@angular/forms';

import { Injectable } from '@angular/core';
import { ApiService } from '../core/api.service';
import { CatalogueService } from '../core/cataloque.service';

@Injectable()
export class ValidatorService {
  constructor(public apiService: ApiService,
    public CatalogueService: CatalogueService) {}

  montoMinimo(control: AbstractControl) :{ [key: string]: any }
  {
    if(control.value < 150000)
    {
      return { error: 'El monto no es suficiente' };
    }
    else
    {
      return null;
    }
  }

  CodigoPromotor(control: AbstractControl)
  {
    return this.apiService
      .send('validator/ValidaCodigoPromocion', { Code: control.value })
      .then(data => 
      {
        if(data== "ok")
        {
          return null;
        }
        else
        {
          return { error: data };
        }
      })
      .catch(error => { return { error: "Error" }; });
  }

  rfc(control: AbstractControl): { [key: string]: any } {
    if (!control.value) return null;
    if (control.value.length > 12) {
      return { error: 'El rfc debe tener una longitud de 12 caracteres.' };
    } else {
      const regx = /[a-zA-Z]{3}[0-9]{6}[a-zA-Z0-9]{3}/;
      if (regx.test(control.value)) {
        return null;
      } else {
        return { error: 'El formato de RFC es invalido.' };
      }
    }
  }
  telefono(control: AbstractControl): { [key: string]: any } {
    if (!control.value) return null;
    if (control.value.length == 10) return null;
    return { error: 'El teléfono debe tener una longitud de 10 caracteres.' };
  }
  telefonoLada(control: AbstractControl): { [key: string]: any } {
    const regx = /[0-9]{3}-[0-9]{12}/;
    if (regx.test(control.value)) {
      return null;
    } else {
      return {
        //error: "Ingrese el formato correcto para el teléfono."
        error: ''
      };
    }
  }
  contrato(control: AbstractControl): { [key: string]: any } {
    if (!control.value) return null;
    if (control.value.length == 20) return null;
    return { error: 'El contrato debe tener una longitud de 20 caracteres.' };
  }
  telReferencia(control: AbstractControl): { [key: string]: any } {
    if (!control.value) return null;
    if (control.value.length > 20) {
      return {
        error: 'El teléfono debe tener una longitud maxima de 20 caracteres.'
      };
    } else {
      return null;
    }
  }

  celular(control: AbstractControl): { [key: string]: any } {
    if (!control.value) return null;
    if (control.value.length == 10) return null;
    return { error: 'El teléfono debe tener una longitud de 10 caracteres.' };
  }

  postalCode(value: string)
  {
    // Heere    
    return this.apiService
      .send('validator/postalcode', { postalCode: value })
      .then(data => {
        return data;
      });
  }

  
  postalCodeSub(value: string) {
    return this.apiService.sendSub('validator/postalcode', {
      postalCode: value
    });

    
  }
}



// WEBPACK FOOTER //
// ./src/app/core/service/app/validator.service.ts